<template>

  <panel-navigation>
    
    <h1 class="text-lg font-semibold mb-3">Support</h1>

    <hr class="border-b border-gray-100 mb-3">

    <div class="dashboard-box stats-box w-full px-2 -mx-2">
      <v-card
        class="pa-2 h-full"
        tile
      >
        <div v-if="me" :class="'w-full mb-3 p-3'">
            <iframe style="width: 100%;" height="850" :src="'https://diy-ai-ticketing-system-450.created.app?email=' + this.me.email" title="DIY AI Ticketing System" frameBorder="0"></iframe>

            <div style="width: 90%; background: #FFFFFF; height: 80px; margin-top: -80px; position: absolute;"></div>
        </div>
      </v-card>
    </div>

  </panel-navigation>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'

export default {
  metaInfo () {
    return {
      title: "Support | " + this.$appName
    }
  },

  computed: {
    ...mapState({
      me: state => state.me.me,
      profile: state => state.me.profile,
    })
  },

  components: {
    PanelNavigation
  },

  data () {
    return {
      
    }
  },

  methods: {
    
  },

  created() {
  }
}
</script>